import { userType } from "../../DTO";
import { Api } from "../api";

export const ReleaseUserLoginIdentifiers = (
    user: userType,
    userId: number,
    fields: Array<"email" | "phone">,
) => {
    const api = new Api({
        method: "patch",
        path: `users/${userId}/release-login-identifiers`,
        header: {
            Authorization: `Bearer ${user.access_token}`,
        },
        body: { fields },
        reject422: true,
    });

    return api.call();
};
